import React, { Component } from 'react';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import Card from 'components/Card/Card.jsx';
import Form from 'react-jsonschema-form';

//Redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as UsersActions from './redux/UsersActions';

import DeleteButton from '../../lib/components/DeleteButton';
import widgets from '../../lib/widgets';
import fields from '../../lib/fields';

import floopbackRelation from '../../lib/floopbackRelations';

const schema = {
    $id: 'http://example.com/example.json',
    type: 'object',
    definitions: {},
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        firstName: {
            $id: '/properties/firstName',
            type: 'string',
            title: 'Nombre',
            default: '',
            examples: ['Ana']
        },
        lastName: {
            $id: '/properties/lastName',
            type: 'string',
            title: 'Apellidos',
            default: '',
            examples: ['Guerrero Lara']
        },
        email: {
            $id: '/properties/email',
            type: 'string',
            title: 'Email',
            default: '',
            examples: ['example@gmail.com']
        },
        password: {
            $id: '/properties/password',
            type: 'string',
            title: 'Contraseña',
            default: '',
            examples: ['example']
        },
        phone: {
            $id: '/properties/phone',
            type: 'string',
            title: 'Teléfono',
            default: '',
            examples: ['443 45 43 45']
        },
        roles: {
            $id: '/properties/roles',
            type: 'array',
            title: 'Rol',
            api: process.env.REACT_APP_URL_API + '/api/roles',
            options: {
                value: 'id',
                label: 'name'
            },
            default: '',
            items: {
                $id: '/properties/roles/items',
                type: 'string',
                title: 'The 0th Schema ',
                default: ''
            },
            examples: ['']
        }
    }
};

const uiSchema = {
    roles: {
        'ui:field': 'SelectMultipleRemoteWidget'
    },
    email: {
        'ui:widget': 'email'
    },
    password: {
        'ui:widget': 'password'
    }
};

const log = type => console.log.bind(console, type);

class UsersForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.match.params.id,
            formData: {
                roles: []
            },
            originalFormData: {},

            deleteSuccess: false
        };
    }

    componentWillMount() {
        if (this.state.id !== 'create') {
            var param = {
                include: ['roles']
            };
            this.props.findById(this.state.id, param);
        }
    }

    componentWillReceiveProps(nextProps) {
        var newFormData = {
            ...nextProps.Users.formData
        };

        var newOriginalFormData = JSON.parse(JSON.stringify(newFormData));

        this.setState({
            formData: newFormData,
            originalFormData: newOriginalFormData
        });
    }

    addRelation(formData, relation) {
        //Multiple Select Relation
        console.log(formData[relation], this.state.originalFormData);
    }

    onSubmit = ({ formData }) => {
        let _this = this;
        if (
            formData.password === '' ||
            formData.password === undefined ||
            formData.password == null
        )
            delete formData.password;

        //Relation
        var roleRelation = new floopbackRelation(
            'users',
            'RoleMappings',
            'roles',
            formData.roles
        );
        delete formData.roles;

        console.log('Data submitted: ', formData);

        if (this.state.id !== 'create') {
            this.props.update(formData.id, formData).then(async function() {
                await roleRelation.save(formData.id, 'roleId', {
                    principalType: 'USER',
                    principalId: formData.id
                });

                _this.props.history.push('/admin/users');
            });
        } else {
            this.props.create(formData).then(async function(result) {
                await roleRelation.save(result.id, 'roleId', {
                    principalType: 'USER',
                    principalId: result.id
                });

                _this.props.history.push('/admin/users');
            });
        }
    };

    onDelete = () => {
        let _this = this;
        this.props.remove(this.state.id).then(() => {
            this.setState({
                deleteSuccess: true
            });
            setTimeout(() => {
                _this.props.history.push('/admin/users');
            }, 2000);
        });
    };

    onBlur = (id, value) => {
        console.log('Data submitted: ', this.state.formData);
    };

    render() {
        let { history } = this.props;
        let { formData } = this.state;
        return (
            <div className="main-content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                title={<legend>Editar Usuario</legend>}
                                content={
                                    <div>
                                        <Form
                                            schema={schema}
                                            fields={fields}
                                            widgets={widgets}
                                            uiSchema={uiSchema}
                                            onSubmit={this.onSubmit}
                                            onBlur={this.onBlur}
                                            formData={formData}
                                            onError={log('errors')}
                                        >
                                            <div>
                                                <Button
                                                    bsStyle="success"
                                                    type="submit"
                                                    className="btn-fill"
                                                >
                                                    Guardar
                                                </Button>{' '}
                                                <Button
                                                    bsStyle="default"
                                                    onClick={() =>
                                                        history.push(
                                                            '/admin/users'
                                                        )
                                                    }
                                                >
                                                    Cancelar
                                                </Button>
                                                <div className="pull-right">
                                                    <DeleteButton
                                                        onConfirm={
                                                            this.onDelete
                                                        }
                                                        success={
                                                            this.state
                                                                .deleteSuccess
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </Form>

                                        <div className="clearfix" />
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        Users: state.Users
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(UsersActions, dispatch);
};

const UsersConnect = connect(
    mapStateToProps,
    mapDispatchToProps
)(UsersForm);

export default UsersConnect;



// WEBPACK FOOTER //
// ./src/views/Users/UsersForm.jsx